export default __webpack_public_path__ + "static/media/zbp_make_payment_icon.884e6368.svg";